module.exports = __webpack_public_path__ + "img/no-user.02f8ad5e.png";